import axios from "axios";
import i18n from "@/locales/i18n";
import { getWebPagesId } from "@/utils/webPage";

const API_URL = "https://prokuroriaapi.cmdsoftwares.com/api/v1/";

class PostService {
  async getPosts() {
    return await axios.get(`${API_URL}post`).then((response) => response.data);
  }

  async getPostsCategory(data) {
    const webPageid = getWebPagesId();
    return await axios
      .post(`${API_URL}dashboard/post-details/list`, {
        webPage: data.webPage,
        prokuroriaId: webPageid || data.prokuroriaId,
        language: i18n.global.locale,
        count: data.count,
        categoryId: data.categoryId,
        postId: data.postId,
      })
      .then((response) => {
        return response.data;
      });
  }

  async getPostsCategoryReports(data) {
   const webPageid = getWebPagesId();
   return await axios
     .post(`${API_URL}dashboard/post-details/list`, {
       webPage: data.webPage,
       prokuroriaId: webPageid || data.prokuroriaId,
       language: i18n.global.locale,
       count: data.count,
       categoryId: data.categoryId,
       postId: data.postId,
     })
     .then((response) => {
       return response.data;
     });
  }

  async getPostsById(data) {
    return await axios
      .post(`${API_URL}dashboard/post-details/id`, {
        webPage: "",
        //language: data.language,
        language: i18n.global.locale,
        count: 0,
        categoryId: 0,
        postId: data.postId,
        prokuroriaId: 0,
      })
      .then((response) => {
        return response.data;
      });
  }
}

export default new PostService();
